import {
  createHistoryItemFirstPart,
  createHistoryAccessKey
} from "../shared/index.js";
const getHistoryByHistoryAccess = async (client, access) => {
  const range = access.timestamp === void 0 ? void 0 : {
    start: null,
    end: [Number.MAX_SAFE_INTEGER - access.timestamp + 1, Number.MAX_SAFE_INTEGER, Number.MAX_SAFE_INTEGER, "~"]
  };
  const claimsResponse = await client.fetchClaims(createHistoryItemFirstPart(access.historyId), null, range);
  return claimsResponse.map((claim) => {
    const keySecondPart = claim.content.key.second_part;
    return {
      ...claim.content.body,
      timestamp: Number.MAX_SAFE_INTEGER - keySecondPart[0],
      step: keySecondPart[1],
      order: keySecondPart[2],
      access
    };
  });
};
const getHistoryAccess = async (client, uniqueId) => {
  const key = createHistoryAccessKey(uniqueId);
  const access = (await client.fetchClaims(key.first_part, key.second_part))[0]?.content.body;
  return access;
};
export {
  getHistoryAccess,
  getHistoryByHistoryAccess
};
//# sourceMappingURL=api.js.map